module.exports = __webpack_public_path__ + "img/main_cn2.fb8b9a7d.svg";